import { render } from "./webhook.add.vue?vue&type=template&id=fbc25398"
import script from "./webhook.add.vue?vue&type=script&lang=js"
export * from "./webhook.add.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__